interface scriptDefinition {
  src?: string | null,
  innerHTML?: string | null,
  tagPosition: 'head' | 'bodyOpen' | 'bodyClose'
}

interface noScriptDefinition {
  src?: string | null,
  innerHTML?: string | null,
  tagPosition: 'head' | 'bodyOpen' | 'bodyClose'
}

export function useExtraScript() {
  const site = useSiteStore()

  return computed(() => {
    const gtmId = site?.data?.googleGtmId
    const scripts: scriptDefinition[] = [
      {
        tagPosition: 'bodyClose',
        innerHTML: `(function(d, w, c) {
          w.SibConversationsID = '602a5d52662aa94d55043659';
          w[c] = w[c] || function() {
              (w[c].q = w[c].q || []).push(arguments);
          };
          var s = d.createElement('script');
          s.async = true;
          s.src = 'https://conversations-widget.sendinblue.com/sib-conversations.js';
          if (d.head) d.head.appendChild(s);
      })(document, window, 'SibConversations');`,
      },
    ]

    if (gtmId) {
      scripts.push({
        tagPosition: 'bodyClose',
        innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');`,
      })
    }
    if (site?.data?.scriptSources?.length) {
      site.data.scriptSources.forEach((item) => {
        scripts.push({
          src: item,
          tagPosition: 'bodyClose',
        })
      })
    }
    if (site?.data?.scriptBodies?.length) {
      site.data.scriptBodies.forEach((item) => {
        scripts.push({
          innerHTML: item,
          tagPosition: 'bodyClose',
        })
      })
    }

    const noscript: noScriptDefinition[] = []
    if (gtmId) {
      noscript.push({
        tagPosition: 'bodyClose',
        innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
      })
    }

    return {
      script: scripts,
      noscript: noscript,
    }
  })
}
